import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  readonly IMG_URL = 'https://marketsmojostatic.motilaloswal.com/';
  readonly FRAPI_URL = 'https://marketsmojoapi.motilaloswal.com/';
  readonly MOJO_WEB_URL = 'https://marketsmojo.motilaloswal.com/';
  readonly MOJO_STOCK_URL = 'https://marketsmojo.motilaloswal.com/stocks-analysis/';
  readonly MOJO_URL = 'https://marketsmojo.motilaloswal.com/';
  readonly APIV1_URL = 'https://marketsmojoapi.motilaloswal.com/apiv1/';
  readonly APIV1_URL_S = 'https://marketsmojoapi.motilaloswal.com/apiv1/';
  readonly JS_URL = 'https://marketsmojostatic.motilaloswal.com/';
  readonly PARTNER_URL = 'https://www.mojomarkets.in/';

  constructor() {}
}
